import React, { FC } from 'react'

import { UniNotice } from 'api/uninotice/UniNotice'
import {
  UniNoticePayload,
  UniNoticeSecondaryHandler,
} from 'api/uninotice/uninotice.types'
import { VoidHandler } from 'common/types'
import { ViewContentInlineNotice } from 'components/uninotice/UniNoticeView.styled'

import { UniNoticeInlineWrapper } from './UniNoticeInline.styled'
import { UniNoticeNavigation } from './UniNoticeNavigation'
import UniNoticeViewContent, {
  UniNoticeInlineView,
} from './UniNoticeViewContent'

export interface CommonNoticeViewProps {
  className?: string
  notice: UniNotice
  onActionClick: VoidHandler
  onSecondaryClick?: UniNoticeSecondaryHandler
  viewWithoutBorder?: boolean
  withNavigation?: boolean
  /** Нужен для того, чтобы с помощью React.createPortal зарендерить кнопку юнинотиса в другом месте DOM */
  primaryButtonPortalContainer?: HTMLElement | null
}

export const CommonNoticeView: FC<CommonNoticeViewProps> = ({
  className,
  notice,
  onActionClick,
  onSecondaryClick,
  viewWithoutBorder,
  withNavigation,
  primaryButtonPortalContainer,
}) => {
  const { noticeId, payload } = notice
  const { text, textTitle, image, imageElement, actionBtn, auxBtn, auxText } =
    payload as UniNoticePayload

  const commonProps = {
    title: textTitle,
    noticeId,
    text,
    imageSource: image,
    /** @TODO UniNoticeInlineView ждет элемент, а не компонент. Зарефакторить! */
    imageComponent: imageElement,
    primaryButton: actionBtn,
    secondaryLink: auxBtn,
    secondaryText: auxText,
    primaryButtonPortalContainer,
    onPrimaryClick: onActionClick,
    onSecondaryClick,
  }

  let uninoticeElement

  if (viewWithoutBorder) {
    uninoticeElement = (
      <UniNoticeInlineView className={className} {...commonProps} />
    )
  } else {
    uninoticeElement = (
      <ViewContentInlineNotice className={className}>
        <UniNoticeViewContent {...commonProps} />
      </ViewContentInlineNotice>
    )
  }

  if (withNavigation) {
    return (
      <UniNoticeInlineWrapper className={className}>
        <UniNoticeNavigation />
        {uninoticeElement}
      </UniNoticeInlineWrapper>
    )
  }

  return uninoticeElement
}
